(ns machtfit.stepchall.views
  (:require [machtfit.startpage.spinner :as spinner]
            [machtfit.startpage.subs :as startpage.subs]
            [machtfit.stepchall.add-activity :as add-activity]
            [machtfit.stepchall.alert-bar :refer [alert-bar]]
            [machtfit.stepchall.create-team :as create-team]
            [machtfit.stepchall.details :as details]
            [machtfit.stepchall.header :as header]
            [machtfit.stepchall.join-team :as join-team]
            [machtfit.stepchall.leaderboard :as leaderboard]
            [machtfit.stepchall.my-steps :as my-steps]
            [machtfit.stepchall.my-team :as my-team]
            [machtfit.stepchall.nav-bar :as nav-bar]
            [machtfit.stepchall.onboarding :as onboarding]
            [machtfit.stepchall.route-view :as route-view]
            [machtfit.stepchall.subs :as subs]
            [machtfit.stepchall.team-list :as team-list]
            [machtfit.stepchall.tracker :as tracker]
            [machtfit.translation :refer [t]]
            [re-frame.core :as rf]))

(rf/reg-sub ::show-team-list?
  :<- [::subs/is-team-member?]
  :<- [::subs/in-team-building-phase?]

  (fn [[is-team-member? in-team-building-phase?] _]
    (and (not is-team-member?) in-team-building-phase?)))

(defn- intro []
  [:<>
   [onboarding/onboarding]
   [tracker/tracker-intro]])

(defn- stepchall-main []
  (let [subpage @(rf/subscribe [:get [:ui :page :subpage]])
        is-team-member? @(rf/subscribe [::subs/is-team-member?])
        is-spectator? @(rf/subscribe [::subs/is-spectator?])]
    [:<>
     [header/header]
     [alert-bar]
     [intro]

     (cond
       is-team-member? (case subpage
                         :leaderboard [leaderboard/leaderboard]
                         :my-steps [my-steps/my-steps]
                         :my-team [my-team/my-team]
                         [route-view/route-view])
       is-spectator? (if (= subpage :leaderboard)
                       [leaderboard/leaderboard]
                       [route-view/route-view])
       :else [route-view/route-view])
     [nav-bar/nav-bar]
     (when @(rf/subscribe [::show-team-list?])
       [team-list/team-list])]))

(defn stepchall []
  (let [is-browser? (not @(rf/subscribe [::startpage.subs/is-app?]))
        active-stepchall? @(rf/subscribe [:get [:user :stepchall-tile]])
        stepchall-loaded? @(rf/subscribe [:get [:stepchall]])]
    [:div.sc {:class [(when is-browser? "sc_browser")
                      (when (not stepchall-loaded?) "loading")]}
     (if active-stepchall?
       (if-not stepchall-loaded?
         [spinner/spinner]
         [:div.container
          (when is-browser? [details/details])
          [:div#sc_app-frame
           [:div#sc_app-frame-inner
            (case @(rf/subscribe [:get [:ui :page :subpage]])
              :join-team [join-team/join-team-page]
              :create-team [create-team/create-team-page]
              :select-activity [add-activity/activities]
              :add-activity [add-activity/activities]
              [stepchall-main])]]])
       [:div.container
        [t {:en "Currently there is no machtfit-Challenge."
            :de "Derzeit gibt es keine machtfit-Challenge."}]])]))
